// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1s8lS","colMaxWidth":"Table_colMaxWidth__2w43S"};